import { rest } from 'msw'

export const mockCreatePaymentLimitPayload = {
  level: 'ALL_CUSTOMERS' as const,
  accountId: '550e8400-e29b-41d4-a716-446655440001',
  method: 'SEPA_INST',
  limitType: 'DAILY' as const,
  amount: 10000,
  currency: 'EUR',
  zoneOffset: 'Z',
}

export const mockCreatedPaymentLimit = {
  id: 'new-rule-id',
  limitType: 'DAILY',
  amount: 10000,
  currency: 'EUR',
  qualifiers: {
    accountId: '550e8400-e29b-41d4-a716-446655440001',
    customerId: null,
    walletId: null,
    bankingPartner: null,
    method: 'SEPA_INST',
  },
  owner: 'ACCOUNT_USER',
  zoneOffset: 'Z',
}

export const mockCreatePaymentLimitResponse = {
  id: 'new-rule-id',
  limitType: 'DAILY',
  amount: 10000,
  currency: 'EUR',
  qualifiers: {
    accountId: 'test-account',
    customerId: null,
    walletId: null,
    bankingPartner: null,
    method: 'SEPA_INST',
  },
  owner: 'ACCOUNT_USER',
  zoneOffset: 'Z',
}

const createdLimits: Array<{
  method: string
  currency: string
  limitType: string
}> = []

const paymentLimitsHandlers = [
  rest.post('*/governance/v1/limits', async (req, res, ctx) => {
    const body = await req.json()
    const limitKey = `${body.method}-${body.currency}-${body.limitType}`
    const isDuplicate = createdLimits.some(
      limit => `${limit.method}-${limit.currency}-${limit.limitType}` === limitKey
    )

    if (isDuplicate) {
      return res(
        ctx.status(409),
        ctx.json({
          message: 'Rule with given arguments already exists',
          status: 409,
        })
      )
    }

    createdLimits.push({
      method: body.method,
      currency: body.currency,
      limitType: body.limitType,
    })

    return res(ctx.json(mockCreatedPaymentLimit))
  }),
]

export default paymentLimitsHandlers
